import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NotFound = ({ isArabic = false }) => {
  const location = useLocation();

  // Log 404 to backend for monitoring (optional)
  useEffect(() => {
    // You can send 404s to analytics or backend for monitoring
    console.warn('404 Page Not Found:', location.pathname);

    // Optional: Log to backend analytics
    // fetch('http://localhost:4001/api/analytics/404', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     path: location.pathname,
    //     referrer: document.referrer,
    //     timestamp: new Date().toISOString()
    //   })
    // }).catch(err => console.error('Failed to log 404:', err));
  }, [location.pathname]);

  const content = {
    en: {
      title: "404 - Page Not Found",
      subtitle: "Oops! The page you're looking for doesn't exist.",
      description: "The page may have been moved, deleted, or you may have mistyped the URL.",
      buttons: {
        home: "Go to Homepage",
        back: "Go Back",
        browse: "Browse Teachers",
        help: "Help Center"
      }
    },
    ar: {
      title: "404 - الصفحة غير موجودة",
      subtitle: "عذراً! الصفحة التي تبحث عنها غير موجودة.",
      description: "ربما تم نقل الصفحة أو حذفها، أو قد تكون أخطأت في كتابة الرابط.",
      buttons: {
        home: "الذهاب للصفحة الرئيسية",
        back: "العودة للخلف",
        browse: "تصفح المعلمين",
        help: "مركز المساعدة"
      }
    }
  };

  const t = content[isArabic ? 'ar' : 'en'];

  return (
    <div className={`min-h-screen bg-gradient-to-br from-[#FFF8F1] via-white to-[#FFF8F1] flex items-center justify-center px-4 ${isArabic ? 'rtl' : 'ltr'}`}>
      <div className="max-w-2xl w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#22305A] to-[#FF7A1A] animate-pulse">
            404
          </div>
          <div className="mt-4">
            <svg className="w-64 h-64 mx-auto opacity-50" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <circle cx="100" cy="100" r="80" fill="#FFF8F1" />
              <circle cx="75" cy="85" r="8" fill="#22305A" />
              <circle cx="125" cy="85" r="8" fill="#22305A" />
              <path d="M 70 130 Q 100 150 130 130" stroke="#22305A" strokeWidth="4" fill="none" strokeLinecap="round" />
              <path d="M 60 60 Q 75 50 90 60" stroke="#22305A" strokeWidth="3" fill="none" strokeLinecap="round" />
              <path d="M 110 60 Q 125 50 140 60" stroke="#22305A" strokeWidth="3" fill="none" strokeLinecap="round" />
            </svg>
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#1A2341] mb-3">
            {t.title}
          </h1>
          <p className="text-xl text-[#22305A] mb-4">
            {t.subtitle}
          </p>
          <p className="text-gray-600">
            {t.description}
          </p>

          {/* Show attempted URL */}
          <div className="mt-4 p-3 bg-[#FFF8F1] rounded-lg inline-block">
            <code className="text-sm text-[#1A2341] break-all">
              {window.location.href}
            </code>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
